var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { PeekButton, PeekDialogContent, PeekDialogActions, PeekStack, PeekDivider, useTheme, PeekGrid, } from "@piiqtechnologies/ui-components";
import { useIntl } from "react-intl";
import { MultiColumnFormFields } from "@components/common/form/FormFields";
import { useUpdateCommunity, useNotification, useRefetch, useLoader, useError, useCreateCommunity, } from "@piiqtechnologies/ui-lib";
import messages from "./messages.i18n";
import { CreateOrEditCommunityFormFields, CreateOrEditFormValidationSchema } from "./CreateOrEditCommunityFormConfig";
import { DeactivateCommunityForm } from "../deactivate-community-form/DeactivateCommunityForm";
export const CreateOrEditCommunityForm = ({ onSubmit, communityFormInitialValues, deactivationOption = false, isCommunityCreation = false, }) => {
    const intl = useIntl();
    const theme = useTheme();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const { setNotification } = useNotification();
    const [createCommunity, communityCreated, communityCreationInProgress, communityCreationError] = useCreateCommunity();
    const [updateCommunity, communityUpdated, communityUpdateInProgress, communityUpdateError] = useUpdateCommunity();
    const [openDeactivateCommunityDialog, setOpenDeactivateCommunityDialog] = useState(false);
    const showDeactivateCommunityDialog = () => {
        setOpenDeactivateCommunityDialog(!openDeactivateCommunityDialog);
    };
    const onDeactivationSuccessful = () => {
        showDeactivateCommunityDialog();
        onSubmit();
    };
    const onCloseDeactivationDialog = () => {
        showDeactivateCommunityDialog();
    };
    const { communityInfo_column1, communitySpacesInfo_column2, communityPlanInfo_column3 } = CreateOrEditCommunityFormFields((communityFormInitialValues === null || communityFormInitialValues === void 0 ? void 0 : communityFormInitialValues._id) || "");
    const onFormSubmit = (_a) => {
        var { address } = _a, values = __rest(_a, ["address"]);
        const communityFormCreationPayload = Object.assign(Object.assign({}, values), { address: {
                longitude: address === null || address === void 0 ? void 0 : address.longitude,
                latitude: address === null || address === void 0 ? void 0 : address.latitude,
                placeId: address === null || address === void 0 ? void 0 : address.placeId,
                postalCode: address === null || address === void 0 ? void 0 : address.postalCode,
                city: address === null || address === void 0 ? void 0 : address.city,
                state: address === null || address === void 0 ? void 0 : address.state,
                country: address === null || address === void 0 ? void 0 : address.country,
                geocodeData: address === null || address === void 0 ? void 0 : address.geocodeData,
                street: (address === null || address === void 0 ? void 0 : address.street) < (address === null || address === void 0 ? void 0 : address.name) ? address === null || address === void 0 ? void 0 : address.street : address === null || address === void 0 ? void 0 : address.name,
                street2: (address === null || address === void 0 ? void 0 : address.description) || (address === null || address === void 0 ? void 0 : address.street2),
            } });
        if (isCommunityCreation) {
            createCommunity(communityFormCreationPayload);
            return;
        }
        updateCommunity(communityFormCreationPayload);
    };
    useEffect(() => {
        setLoader(communityUpdateInProgress, "communityUpdateInProgress");
        return () => setLoader(false, "communityUpdateInProgress");
    }, [communityUpdateInProgress]);
    useEffect(() => {
        setLoader(communityCreationInProgress, "communityCreationInProgress");
        return () => setLoader(false, "communityCreationInProgress");
    }, [communityCreationInProgress]);
    useEffect(() => {
        if (communityUpdateError) {
            setError(communityUpdateError === null || communityUpdateError === void 0 ? void 0 : communityUpdateError.message);
        }
    }, [communityUpdateError]);
    useEffect(() => {
        if (communityCreationError) {
            setError(communityCreationError === null || communityCreationError === void 0 ? void 0 : communityCreationError.message);
        }
    }, [communityCreationError]);
    useEffect(() => {
        if (communityCreated || communityUpdated) {
            setNotification(isCommunityCreation
                ? intl.formatMessage(messages.communitySuccessCreation)
                : intl.formatMessage(messages.communitySuccessUpdate));
            setRefetch();
            onSubmit();
        }
    }, [communityUpdated, communityCreated]);
    const CommunityFormInitialValues = communityFormInitialValues || {
        plan: "",
        name: "",
        //@ts-ignore
        features: [],
        organization: {
            _id: "",
        },
        communityContact: {
            contactPhone: "",
        },
        metroArea: "",
        leadsEmail: "",
        address: "",
        timezone: "",
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Formik, { initialValues: CommunityFormInitialValues, validationSchema: CreateOrEditFormValidationSchema(), onSubmit: onFormSubmit },
            React.createElement(Form, null,
                React.createElement(PeekDialogContent, null,
                    React.createElement(PeekGrid, { container: true, direction: "row" },
                        React.createElement(PeekGrid, { item: true, xs: 12 },
                            React.createElement(MultiColumnFormFields, { fullWidth: true, fields: communityInfo_column1.communityInfo })),
                        React.createElement(PeekGrid, { item: true, xs: 12 },
                            React.createElement(PeekDivider, { orientation: "horizontal", light: true, sx: { my: theme.spacing(1) } }),
                            React.createElement(MultiColumnFormFields, { fullWidth: true, fields: communitySpacesInfo_column2.communitySpacesInfo })),
                        React.createElement(PeekGrid, { item: true, xs: 12 },
                            React.createElement(PeekDivider, { orientation: "horizontal", light: true, sx: { my: theme.spacing(1) } }),
                            React.createElement(MultiColumnFormFields, { fullWidth: true, fields: communityPlanInfo_column3.communityPlanInfo })))),
                React.createElement(PeekDialogActions, null,
                    React.createElement(PeekStack, { width: "100%", spacing: theme.spacing(1) },
                        React.createElement(PeekButton, { size: "large", fullWidth: true, type: "submit", color: "primary", variant: "contained" }, isCommunityCreation
                            ? intl.formatMessage(messages.communityCreate)
                            : intl.formatMessage(messages.communityUpdate)),
                        deactivationOption && (React.createElement(PeekButton, { size: "large", fullWidth: true, onClick: showDeactivateCommunityDialog, color: "error", variant: "outlined" }, intl.formatMessage(messages.communityUpdateDeactivation))))))),
        openDeactivateCommunityDialog && (React.createElement(DeactivateCommunityForm, { communityId: communityFormInitialValues._id, onClose: onCloseDeactivationDialog, onDeactivationSuccessful: onDeactivationSuccessful }))));
};
export default CreateOrEditCommunityForm;
